<template>
  <div class="article-left-content__wrapper">
    <article-above-body
      :article="article"
      :show-disclaimer="showDisclaimer"
      @enlarge="$emit('enlarge', $event)"
    />
    <slot />
    <article-below-body
      :article="article"
      :show-disclaimer="showDisclaimer"
      v-on="$listeners"
    />
  </div>
</template>

<script>
import { PROP_TYPES, propValidator } from '@/utils/validators'
import ArticleAboveBody from './ArticleAboveBody'
import ArticleBelowBody from './ArticleBelowBody'

export default {
  name: 'ArticleLeftContent',
  components: {
    ArticleAboveBody,
    ArticleBelowBody
  },
  props: {
    article: propValidator([PROP_TYPES.OBJECT]),
    showDisclaimer: propValidator([PROP_TYPES.BOOLEAN], false, false)
  }
}
</script>
